import React, { Component } from "react";
import { IconButton, InputBase, Toolbar, withStyles } from "@material-ui/core";
import NextIcon from "@material-ui/icons/NavigateNext";
import PrevIcon from "@material-ui/icons/NavigateBefore";
import { fade } from "@material-ui/core/styles/colorManipulator";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";

const styles = theme => ({
  root: {
    width: "100%"
  },
  grow: {
    flexGrow: 1
  },
  buttonContainer: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    padding: 0,
    margin: 0,
    minHeight: 48
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    margin: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto"
    }
  },
  searchIcon: {
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit",
    width: "100%"
  },
  inputInput: {
    paddingLeft: theme.spacing.unit * 3,
    transition: theme.transitions.create("width"),
    width: "100%"
  },
  iconButton: {
    width: "20px",
    height: "20px"
  },
  filterBar: {
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
    minHeight: 0,
    margin: 0
  }
});

export const WBToolbarMode = Object.freeze({
  READ: Symbol("read"),
  EDIT: Symbol("edit")
});

class WBToolbar extends Component {
  state = {
    filterText: ""
  };

  getMode = () => {
    let { wbToolbarMode } = this.props;
    if (!wbToolbarMode) {
      wbToolbarMode = WBToolbarMode.EDIT;
    }
    return wbToolbarMode;
  };

  render() {
    const { filterText } = this.state;
    const { classes, onFilter, onNext, onPrev, onAdd, canAdd } = this.props;
    const mode = this.getMode();

    return (
      <div className={classes.root}>
        <Toolbar className={classes.filterBar}>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              value={filterText}
              onChange={event => {
                this.setState({ filterText: event.target.value });
                onFilter(event.target.value);
              }}
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput
              }}
            />
          </div>
          <div className={classes.grow} />
          <div className={classes.buttonContainer}>
            {onPrev ? (
              <IconButton color="inherit" onClick={onPrev}>
                <PrevIcon />
              </IconButton>
            ) : (
              undefined
            )}
            {onNext ? (
              <IconButton color="inherit" onClick={onNext}>
                <NextIcon />
              </IconButton>
            ) : (
              undefined
            )}
            {onAdd && mode === WBToolbarMode.EDIT ? (
              <IconButton color="primary" onClick={onAdd}>
                <AddIcon />
              </IconButton>
            ) : (
              undefined
            )}
          </div>
        </Toolbar>
      </div>
    );
  }
}

export default withStyles(styles)(WBToolbar);
